import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './route';
import NProgress from 'nprogress';
import store from '../store';
import requsetURL from '../../public/defaultRequest.js';

// 解决 3.0.7之上的版本报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(VueRouter);
const router = new VueRouter({ mode: 'history', base: process.env.BASE_URL, routes });
router.beforeEach((to, from, next) => {
    document.title = '“832平台”供应商和商品信息查询系统';
    NProgress.start();
    if (to.path !== '/' && sessionStorage.getItem('selfMenu') && sessionStorage.getItem('selfMenu').indexOf(to.meta.selfFlg) === -1) {
        window.location.replace(
            `${requsetURL}/auth/logout?token=${JSON.parse(
                window.sessionStorage.getItem('token')
            )}&response_type=code&client_id=gongxiao_basic&redirect_uri=${requsetURL}/api/basic/auth/loginSuccess?state=kk`
        );
    }
    next();
});
router.afterEach(() => {
    NProgress.done();
});
export default router;
